import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * @deprecated Use standalone functions from window-helper.utils.ts instead.
 */
@Injectable({
  providedIn: 'root'
})
export class WindowHelperService {
  /**
   * @deprecated Use getWindow from window-helper.utils.ts instead.
   */
  getWindow(): Window {
    return window;
  }

  /**
   * @deprecated Use getLocation from window-helper.utils.ts instead.
   */
  getLocation(): Location {
    return window.location;
  }

  /**
   * @deprecated Use openUrlInNewTab from window-helper.utils.ts instead.
   */
  openUrlInNewTab(url: string): Window {
    return window.open(url, '_blank');
  }

  /**
   * @deprecated Use openUrl from window-helper.utils.ts instead.
   */
  openUrl(url: string): Window {
    return window.open(url, '_self');
  }

  /**
   * @deprecated Use redirectToOrigin from window-helper.utils.ts instead.
   */
  redirectToOrigin(path?: string): void {
    let resultUrl = window.location.origin;

    if (path) {
      resultUrl += '/' + path.replace(/^\/+/, '');
    }

    this.openUrl(resultUrl);
  }

  /**
   * @deprecated Use observeResize from window-helper.utils.ts instead.
   */
  observeResize(element: HTMLElement): Observable<ResizeObserverEntry[]> {
    return new Observable((observer) => {
      const resizeObserver = new ResizeObserver((resizeObserverEntries: ResizeObserverEntry[]) => {
        observer.next(resizeObserverEntries);
      });
      resizeObserver.observe(element);
      return () => resizeObserver.disconnect();
    });
  }

  /**
   * @deprecated Use getCurrentUrl from window-helper.utils.ts instead.
   */
  getCurrentUrl(): string {
    return location.pathname + location.search;
  }
}
